import React, { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

interface ConfirmationModalState {
  display: boolean,
  callback: VoidFunction
}

interface Props {
  confirmationModalState: ConfirmationModalState
  closeCallback: VoidFunction
}

const ConfirmationModal: FC<Props> = (props) => {
  const { t } = useTranslation()

  const {
    confirmationModalState,
    closeCallback,
  } = props

  const [scrollY, setScrollY] = useState<number>(0)

  useEffect(() => {
    const html = document.querySelector('html')
    if (!html) return
    if (confirmationModalState.display) {
      const scroll = window.scrollY
      html.classList.add('modal_open')
      html.style.top = `-${scroll}px`
      setScrollY(scroll)
    } else {
      html.classList.remove('modal_open')
      window.scrollTo(0, scrollY)
      setScrollY(0)
    }
  }, [confirmationModalState.display])

  return (
    <>
      {
        confirmationModalState.display && (
          <div className="modal_wrap">
            <div className={`confirmation_modal ${confirmationModalState.display || 'none'}`} style={{ width: "500px" }}>
              <div className="confirmation_modal_header">
                <div className="title">
                  {t('setting.profile.button.delete')}
                </div>
                <button type="button" className="close_modal" onClick={closeCallback}>
                  &times;
                </button>
              </div>
              <div className="confirmation_modal_body">
                <p>
                  {t('setting.profile.modal.delete.confirm')}
                </p>
              </div>
              <div className="confirmation_modal_footer">
                <button type="button" className="button cancel" onClick={closeCallback}>
                  {t('form.component.cancel')}
                </button>
                <button
                  type="button"
                  className="button delete"
                  onClick={() => {
                    confirmationModalState.callback()
                    closeCallback()
                  }}
                >
                  {t('form.component.delete')}
                </button>
              </div>
            </div>
            <div className="close_screen gray" role="presentation" onClick={closeCallback} />
          </div>
        )
      }
      <div className={`screen ${confirmationModalState.display || 'none'}`} />
    </>
  )
}

export default ConfirmationModal
